
import { motion, useAnimation } from "framer-motion";

type AnimationControls = ReturnType<typeof useAnimation>;

interface AnimatedLogoProps {
  logoControls: AnimationControls;
  isMobile: boolean;
}

export const AnimatedLogo = ({ logoControls, isMobile }: AnimatedLogoProps) => {
  return (
    <motion.div
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
      className="fixed top-0 left-0 right-0 flex justify-center z-20 px-4 mt-4 sm:mt-8 pointer-events-none"
    >
      <motion.div 
        animate={logoControls}
        className="flex flex-col items-center"
      >
        <img 
          src="/lovable-uploads/ab73c515-76e7-4faa-ba6e-5f7f338d0ec1.png"
          alt="Solucionar Soldas Logo"
          className={`${isMobile ? 'w-48' : 'w-64'} drop-shadow-lg pointer-events-none`}
        />
        <div className="text-center mt-2">
          <h1 className="text-[#004080] font-bold text-xl md:text-2xl">Solucionar Soldas</h1>
          <p className="text-[#0073B7] text-sm md:text-base">Especialistas em Soldagem Industrial</p>
        </div>
      </motion.div>
    </motion.div>
  );
};
